import { useQuery } from "@apollo/client/react";

import { BillingTierFeature, SearchBlueprintsOutput } from "types/generated";
import useTierFeature from "views/Account/hooks/useTierFeature";

import { CHECK_BLUEPRINTS } from "./gql";

const useBlueprintsCheck = () => {
  const isFeatureEnabled = useTierFeature(BillingTierFeature.Blueprints);

  const { loading, data } = useQuery<{
    searchBlueprints: SearchBlueprintsOutput;
  }>(CHECK_BLUEPRINTS, {
    fetchPolicy: "no-cache",
    skip: isFeatureEnabled,
  });

  const hasBlueprints = loading ? undefined : !!data?.searchBlueprints.edges.length;

  return {
    checking: loading,
    showUpSell: !isFeatureEnabled && hasBlueprints === false,
  };
};

export default useBlueprintsCheck;
